import { apiFetch } from "./apiClient";
import CONFIG from "../config";

export async function listScenarios({ isActive, visibility, status } = {}) {
  const url = new URL(`${CONFIG.apiUrl}api/scenarios`);
  if (isActive !== undefined) url.searchParams.append("is_active", isActive.toString());
  if (visibility) url.searchParams.append("visibility", visibility);
  if (status) url.searchParams.append("status", status);
  const response = await apiFetch(url.toString());
  return response?.scenarios || (Array.isArray(response) ? response : []);
}

export async function getScenario(scenarioId) {
  return apiFetch(`${CONFIG.apiUrl}api/scenarios/${encodeURIComponent(scenarioId)}`);
}

export async function createScenario(data) {
  return apiFetch(`${CONFIG.apiUrl}api/scenarios`, { method: "POST", body: JSON.stringify(data) });
}

export async function updateScenario(scenarioId, data) {
  return apiFetch(`${CONFIG.apiUrl}api/scenarios/${encodeURIComponent(scenarioId)}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteScenario(scenarioId) {
  return apiFetch(`${CONFIG.apiUrl}api/scenarios/${encodeURIComponent(scenarioId)}`, { method: "DELETE" });
}
